<!--  -->
<template>
  <div style="padding: 20px;" class="richTextParsing">
    <div  v-html="content"></div>
  </div>
</template>

<script>
import { appraiseIndex } from '@/api/excellentStation'
import { mapMutations } from 'vuex'
  export default {
    name: "excellentStationRichText",
    data() {
      return {
        content: "",
      }
    }, 
    //生命周期 - 创建完成（访问当前this实例）
    created() {
      // https://test-manager-center.xianglin.cn/#/excellentStationRichText?id=25&token=d63369e3630e0d92916485a711b71fb7&userId=119
      let token = this.$route.query.token;
      let userId = this.$route.query.userId;
      this.getContent()
      this.updateUser({ 
        token,
        userId
      })

    },
    //生命周期 - 挂载完成（访问DOM元素）
    mounted() {
      document.title = "标杆站长任务得分规则"
    },
    methods: {
      ...mapMutations(['updateUser']),
      getContent() {
        appraiseIndex().then((res) => {
          if (res.code == 200) {
            this.content = res.data[0]?res.data[0].rules:""
          } 
        });
      },
      
    }
  }
</script>
<style>
  /* @import url(); 引入css类 */
  .richTextParsing img {
    max-width: 100%!important;
    height: auto!important;
  }
</style>